module.exports = __webpack_public_path__ + "static/imbiased-dcd21eed1496f44c51fe75aa97345602.jpg";